import { FC } from 'react';
import { Row, StaleSidebar } from 'components';
import {
  SidebarPageTemplateContent,
  SidebarPageTemplateHeader,
} from './SidebarPageTemplate.styles';
import { PageHeader } from 'components/shared/PageHeader/PageHeader';
import useDeviceWidth from 'hooks/useDeviceWidth';
import SidebarMobile from './components/SidebarMobile/SidebarMobile';
import { useLocation } from 'react-router';

const HIDE_ICON_LABEL_PATHNAMES = [
  '/app/dashboard',
  '/app/my-clients',
  '/app/settings',
];
const TITLE_PER_PATHNAME = {
  '/app/dashboard': 'Dashboard',
  '/app/my-clients': 'My Clients',
  '/app/reports': 'FX Gains & Losses breakdown',
  '/app/settings': 'Settings',
};
const WITH_BREADCRUMBS_PATHNAMES = [
  '/app/invoices/manual-upload',
  '/app/invoices',
  '/app/invoices/payment-run',
  '/app/invoices/prebookings',
];
const WITH_PROFILE_NAV_PATHNAMES = [
  '/app/invoices/manual-upload',
  '/app/contacts',
  '/app/dashboard',
  '/app/invoices',
  '/app/my-clients',
  '/app/invoices/payment-run',
  '/app/invoices/prebookings',
  '/app/reports',
  '/app/settings',
];

const SidebarPageTemplate: FC = ({ children }) => {
  const { isMobile } = useDeviceWidth();
  const { pathname } = useLocation();
  const withBreadCrumbs = WITH_BREADCRUMBS_PATHNAMES.includes(pathname);
  const hideIconLabels = HIDE_ICON_LABEL_PATHNAMES.includes(pathname);
  const title = TITLE_PER_PATHNAME[pathname];

  return (
    <Row flex={1}>
      {!isMobile && <StaleSidebar hideIconLabels={hideIconLabels} />}

      <SidebarPageTemplateContent>
        {(title || withBreadCrumbs) && (
          <SidebarPageTemplateHeader>
            {isMobile && <SidebarMobile />}
            <PageHeader
              title={title}
              withBreadCrumbs={withBreadCrumbs}
              withProfileNav={WITH_PROFILE_NAV_PATHNAMES.includes(pathname)}
            />
          </SidebarPageTemplateHeader>
        )}
        {children}
      </SidebarPageTemplateContent>
    </Row>
  );
};

export default SidebarPageTemplate;
